import { useMutation } from '@tanstack/react-query';
import { useOptionalDependency } from 'ditox-react';
import { useNavigate } from 'react-router';
import { FIREBASE_MANAGER_TOKEN } from '@/container';
import { useCommDispatcher } from '@/hooks/comm/use-comm';
import ROUTES from '@/routes';
import { useAuthStore } from '@/stores/auth';
import { fetcher } from '@/utils/fetcher';

export default function useSignOut() {
  const navigate = useNavigate();
  const { dispatch } = useCommDispatcher();
  const firebaseManager = useOptionalDependency(FIREBASE_MANAGER_TOKEN);

  const disposeServices = async () => {
    await firebaseManager?.revokeDeviceToken().catch(console.warn);
    dispatch({ event: 'sign-out' });
  };

  const mutation = useMutation({
    mutationKey: ['/Logout'],
    mutationFn: () => fetcher('/Logout', undefined),
    onMutate: () => {
      disposeServices();
    },
    onSettled: () => {
      useAuthStore.getState().stop(false);
      navigate(ROUTES.AUTH.SIGN_IN.$path());
    },
    onError: undefined,
    retry: false,
  });

  return {
    ...mutation,
    disposeServices,
  };
}
